// 对当前接口请求的config添加token
export const addTokenConfig = (config = {}) => {
    config.headers['authorization'] = localStorage.getItem('authorization') || '';
    config.headers['grayKey'] = localStorage.getItem('grayKey') || '';
    config.headers['requestSource'] = localStorage.getItem('requestSource') || '';
    console.log('config>>>>>', config);
    return config;
}

// 当接口返回为token过期时，跳转微信小程序登录页面
export const jumpToWeChatLogin = (response = {}) => {
    const resData = response.data || {};
    if (resData.code !== -1) return true;
    // 判断是否为微信小程序打开的页面
    if (isWeChatMiniProgram()) {
        // 跳转到微信小程序登录页面
        wx.miniProgram.reLaunch({
            url: '/pages/user/authorization/index'
            // url: '/pages/user/login/index'
        });
    }
    return false;
}

// 判断是否为微信小程序打开的页面
export const isWeChatMiniProgram = () => {
    //判断是否为微信内部登录
    var ua = window.navigator.userAgent.toLowerCase();
    //console.log(ua);
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true; //是微信内部
    } else {
        return false;
    }
}
